export const REGULATORY_ASSISTANT_MUNICIPALITY_CODE = "58227"

export enum RegulatoryAssistantMode {
	Parcel = "parcel",
	/** @lintignore */
	Zone = "zone",
	General = "general",
}

export enum RegulatoryAssistantConfidence {
	High = "high",
	Medium = "medium",
	Low = "low",
}

export enum RegulatoryAnswerCategoryKey {
	CurrentRights = "current_rights",
	RegulatoryPotential = "regulatory_potential",
	SiteConstraints = "site_constraints",
}

export enum RegulatoryMessageKind {
	Question = "question",
	Answer = "answer",
	Error = "error",
}

export enum RegulatoryAssistantFailure {
	Stopped = "stopped",
	Failed = "failed",
}

type RegulatoryLink = {
	label: string
	href: string
}

export type RegulatoryAnswerItem = {
	title: string
	detail: string
	meta: string[]
	links: RegulatoryLink[]
}

export type RegulatoryAnswerCategory = {
	key: RegulatoryAnswerCategoryKey
	title: string
	items: RegulatoryAnswerItem[]
}

type RegulatoryAnswer = {
	title: string
	summary: string
	categories: RegulatoryAnswerCategory[]
	keyPoints: string[]
	parcelContext: string[]
	zoneContext: string[]
	watchouts: string[]
}

export type PlanningPolicySource = {
	name: string
	type: string | null
	version: string | null
	minUnitsPerHectare: number | null
	mapUrl: string | null
	documentUrl: string | null
}

type RegulatoryContextCard = {
	label: string
	parcelId: string | null
	zoneCodes: string[]
	activeFlags: string[]
	planningPolicySources: PlanningPolicySource[]
}

export type RegulatoryReference = {
	id: string
	label: string
	documentType: string | null
	coverage: string | null
	articleRef: string | null
	url: string | null
}

export type RegulatoryAssistantResponse = {
	mode: RegulatoryAssistantMode
	confidence: RegulatoryAssistantConfidence
	answer: RegulatoryAnswer
	contextCard: RegulatoryContextCard | null
	references: RegulatoryReference[]
}

type RegulatoryQuestionMessage = {
	kind: RegulatoryMessageKind.Question
	id: string
	question: string
}

type RegulatoryAnswerMessage = {
	kind: RegulatoryMessageKind.Answer
	id: string
	response: RegulatoryAssistantResponse
	durationMs: number
}

type RegulatoryErrorMessage = {
	kind: RegulatoryMessageKind.Error
	id: string
	failure: RegulatoryAssistantFailure
	question: string
	durationMs: number
}

export type RegulatoryMessage = RegulatoryQuestionMessage | RegulatoryAnswerMessage | RegulatoryErrorMessage
